const sortOrders = {
    ascend: 'ASC',
    descend: 'DESC',
}

const getSortBy = ({ column, field } = {}) => {
    if (column?.sortField) return column.sortField
    return Array.isArray(field) ? field.join('.') : field
}

export const normalizeTableSorter = (sorter) => {
    const activeSorter = Array.isArray(sorter) ? sorter.find(({ order }) => order) : sorter
    const sortType = sortOrders[activeSorter?.order]

    return sortType ? {
        sortBy: getSortBy(activeSorter),
        sortType,
    } : {}
}
